"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Image_1 = __importDefault(require("../Image"));

var Asset_1 = require("../Asset/Asset");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Item_1 = __importDefault(require("./styledComponents/Item"));

var Placeholder_1 = __importDefault(require("./styledComponents/Placeholder"));

var Scale_meta_1 = require("./Scale.meta");

var VisuallyHidden_1 = __importDefault(require("../VisuallyHidden"));

var Scale =
/** @class */
function (_super) {
  __extends(Scale, _super);

  function Scale(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Scale_meta_1.SCALE_CATEGORY_KEY;
    _this.componentKey = Scale_meta_1.SCALE_COMPONENT_KEY;
    return _this;
  }

  Scale.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        _b = _a.value,
        value = _b === void 0 ? 0 : _b,
        _c = _a.max,
        max = _c === void 0 ? 4 : _c,
        placeholder = _a.placeholder;
    var collection = [];

    for (var i = 1; i <= max; i++) {
      collection.push(value >= i);
    }

    if (placeholder && !value) {
      return react_1.default.createElement(Placeholder_1.default, null, placeholder);
    }

    return react_1.default.createElement(Asset_1.AssetContext.Consumer, null, function (assetContext) {
      return react_1.default.createElement(Wrapper_1.default, {
        className: className
      }, collection.map(function (selected, index) {
        var asset = 'base.scale.empty';

        if (selected) {
          asset = 'base.scale.filledDefault';
          var assets = assetContext.assets;

          if (assets && assets.base && assets.base.scale && assets.base.scale.overrides) {
            var overrideIndex = assets.base.scale.overrides.findIndex(function (override) {
              return override.asset && override.value === value;
            });

            if (overrideIndex !== -1 && typeof overrideIndex === 'number') {
              asset = "base.scale.overrides[" + overrideIndex + "].asset";
            }
          }
        }

        return react_1.default.createElement(Item_1.default, {
          key: index,
          "aria-hidden": true
        }, react_1.default.createElement(Image_1.default, {
          asset: asset
        }));
      }), react_1.default.createElement(VisuallyHidden_1.default, null, value));
    });
  };

  Scale = __decorate([mobx_react_1.observer], Scale);
  return Scale;
}(shared_1.ComponentBase);

exports.Scale = Scale;
exports.default = shared_1.InjectedStyledComponent(Scale, Scale_meta_1.SCALE_CATEGORY_KEY, Scale_meta_1.SCALE_COMPONENT_KEY);